import React from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@alm/flow-ds/components";
import { useSelector } from "react-redux";

import CardColumn from "components/CardColumn";
import { getCheckedBoxes } from "data/app/appSelectors";
import InstancesMenu from "./InstancesMenu";

interface Props {
	isActive: boolean;
	handleSelectAllCheckboxesClick: () => void;
	instancesCount: number;
	loading?: boolean;
}

function ActivityInstancesHeading({
	isActive,
	handleSelectAllCheckboxesClick,
	instancesCount,
	loading,
}: Props) {
	const { t } = useTranslation();

	const checkboxes: string[] = useSelector(getCheckedBoxes);

	return (
		<div className="list-group-links activity-instances__heading--container">
			<div className="activity-instances__heading">
				<span className="list-group-card-link">
					<CardColumn width="none">
						<Checkbox
							id={`selectAllCheckboxes`}
							checked={checkboxes.length === instancesCount}
							value={!!checkboxes.length as unknown as string}
							onChange={handleSelectAllCheckboxesClick}
							label=""
							ariaLabel="Select all instances"
							className="activity-instances-checkbox"
							disabled={loading ? true : false}
						/>
					</CardColumn>
					<CardColumn width="xl">
						{t("main.activityInstances.headings.id")}
					</CardColumn>
					<CardColumn width="xl">
						{t("main.activityInstances.headings.workflow")}
					</CardColumn>
					<CardColumn width="sm">
						{t("main.activityInstances.headings.status")}
					</CardColumn>
					<CardColumn width="lg">
						{t("main.activityInstances.headings.created")}
					</CardColumn>
					<CardColumn
						width="sm"
						className="activity-instances-card--heading__created-by">
						{t("main.activityInstances.headings.createdBy")}
					</CardColumn>
					<CardColumn
						className={`activity-instances-card__menu ${
							checkboxes.length
								? ""
								: "activity-instances-card__menu-hidden"
						} ${loading ? "disabled" : ""}`}
						width="xs">
						<InstancesMenu
							isActive={isActive}
							isDisabled={!checkboxes.length}
						/>
					</CardColumn>
				</span>
			</div>
		</div>
	);
}

export default ActivityInstancesHeading;
